import React, { useState } from 'react';

import { useParams } from 'react-router-dom';

import ProductMarketingAll from './ProductMarketingAll';

import PreviewMarketingModal from '../preview-modal/PreviewMarketingModal';

import { useGetProductFullView } from 'hooks';

import { useQueryMarketingAssets } from 'pages/product-full-view/queries';

import './ProductMarketingVideo.less';

const ProductMarketingVideo = (props) => {
  const { getImagery, isAllowEdit, getProductDetail } = props;

  const { id } = useParams();

  const [isOpenPreview, setIsOpenReview] = useState(false);

  const { data: marketingAssets, invalidateMarketingAssets } =
    useQueryMarketingAssets({ productId: id });

  const { productFull } = useGetProductFullView({ productId: id });

  const gtin = productFull?.gtin;
  const rivirId = productFull?.rivirId;
  const upc12 = productFull?.upc12;

  const productName = productFull?.productName;
  const productTitle =
    productName && productName !== 'null' ? `- ${productName}` : '';

  const getMarketingAssets = () => {
    if (productFull) {
      invalidateMarketingAssets(id);
    }
  };

  return (
    <>
      <ProductMarketingAll
        itemList={marketingAssets}
        openPreview={() => setIsOpenReview(true)}
        getMarketingAssets={getMarketingAssets}
        getImagery={getImagery}
        isAllowEdit={isAllowEdit}
        getProductDetail={getProductDetail}
      />
      <PreviewMarketingModal
        visible={isOpenPreview}
        productInfo={productFull}
        onCloseModal={() => {
          setIsOpenReview(false);
          //* reload image list
          getMarketingAssets();
        }}
        imageList={marketingAssets}
        getImagery={getImagery}
        getMarketingAssets={getMarketingAssets}
        titleModal={
          gtin
            ? `${gtin} ${productTitle}`
            : upc12
            ? `${upc12} ${productTitle}`
            : rivirId
            ? `${rivirId} ${productTitle}`
            : ''
        }
        title={'Marketing'}
      />
    </>
  );
};
export default ProductMarketingVideo;
